<template>
  <div class="w-full sm:max-w-368 px-16 sm:px-0">
    <slot />
    <form class="flex flex-col mt-24" @submit.prevent="submitForm">
      <h1 class="text-h3">Let's describe what will happen during your Adventure</h1>
      <NoteBox v-if="noteBoxMessage" header="DON'T OVERTHINK IT!" :body="noteBoxMessage" />
      <div class="mt-24 mb-36" style="height: 186px">
        <TextArea
          id="Description-textarea"
          ref="textAreaComponent"
          v-model="description"
          labelName="Description"
          :characterCounter="true"
          :minCharacters="minCharacters"
          :maxCharacters="maxCharacters"
          propClasses="resize-none h-full"
          class="h-full"
          :status="validationType"
          @text-area-status="textAreaStatusHandler"
        />
      </div>
      <div>
        <button class="text-left link-secondary underline mt-16 mb-24 w-auto" @click.prevent="showExamples">See examples</button>
      </div>
      <StickyButton v-if="!showPopup" :value="isEdit ? 'Save' : 'Next'" type="submit" />
    </form>

    <Popup v-model="showPopup" popupHeader="Examples" popupSize="lg">
      <DescriptionExamples />
    </Popup>
  </div>
</template>

<script lang="ts">
// components
import TextArea from '../../../components/textarea/TextArea.vue';
import helperStatus from '../../../helpers/status';
import NoteBox from '../../../components/note_box/NoteBox.vue';
import StickyButton from '../../../components/sticky_button/StickyButton.vue';
import Popup from '../../../components/popup/Popup.vue';
import DescriptionExamples from '../create/examples/DescriptionExamples.vue';

export default {
  name: 'Description',
  components: { TextArea, NoteBox, StickyButton, Popup, DescriptionExamples },
  props: {
    adventureMetaData: {
      default: () => {},
      type: Object,
    },
    isEdit: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      description: this.$store.getters['adventures/adventureDraft'].description || '',
      validationType: helperStatus.Neutral,
      showPopup: false,
    };
  },
  computed: {
    minCharacters(): number {
      return 75;
    },
    maxCharacters(): number {
      return 500;
    },
    noteBoxMessage(): string {
      return this.adventureMetaData?.categories?.[0].descriptionExample || '';
    },
  },
  methods: {
    textAreaStatusHandler(validationType) {
      this.validationType = validationType;
    },
    showExamples() {
      this.showPopup = true;
    },
    submitForm() {
      if (this.validationType !== helperStatus.Valid) {
        // @ts-ignore
        this.$refs.textAreaComponent.checkValidation();
      } else {
        this.setDescription();
      }
      return false;
    },
    async setDescription() {
      await this.$store.dispatch('adventures/updateStore', { description: this.description.trim() });
      this.$router.push({
        path: this.isEdit ? `/adventures/${this.$store.getters['adventures/adventureId']}/edit` : '/adventures/new/passion',
      });
    },
  },
};
</script>
